import { lazy } from 'react';

// Lazy load pages for code splitting
export const Login = lazy(() => import('../pages/Login'));
export const Register = lazy(() => import('../pages/Register'));
export const DefinirNovaSenha = lazy(() => import('../pages/DefinirNovaSenha'));
export const VerificarEmail = lazy(() => import('../pages/VerificarEmail'));

export const Home = lazy(() => import('../pages/aluna/Home'));

export const MyCommunities = lazy(() => import('../pages/MyCommunities'));

// Aluna pages
export const Dashboard = lazy(() => import('../pages/aluna/Dashboard'));

// Chapter pages
export const ChapterOverview = lazy(() => import('../pages/aluna/aulas/ChapterOverview'));
export const AulasPlaylist = lazy(() => import('../pages/aluna/aulas/AulasPlaylist'));

// Comece pages
export const Apresentacao = lazy(() => import('../pages/aluna/comece/Apresentacao'));

// Debates pages
export const Indicacoes = lazy(() => import('../pages/aluna/debates/Indicacoes'));
export const Relacionamento = lazy(() => import('../pages/aluna/debates/Relacionamento'));
export const Sonhos = lazy(() => import('../pages/aluna/debates/Sonhos'));
export const Trabalho = lazy(() => import('../pages/aluna/debates/Trabalho'));
export const Desabafo = lazy(() => import('../pages/aluna/debates/Desabafo'));
export const AssuntosGerais = lazy(() => import('../pages/aluna/debates/AssuntosGerais'));
export const Capitulos = lazy(() => import('../pages/aluna/debates/Capitulos'));
export const SalaDeEspera = lazy(() => import('../pages/aluna/debates/SalaDeEspera'));
export const GirlsPlaining = lazy(() => import('../pages/aluna/debates/Girlsplaining'));

export const Shop = lazy(() => import('../pages/aluna/Shop'));
export const Avisos = lazy(() => import('../pages/aluna/Avisos'));

export const PostPage = lazy(() => import('../pages/aluna/PostPage'));
export const Configuracoes = lazy(() => import('../pages/aluna/Configuracoes'));

// Public pages
export const FormStudent = lazy(() => import('../pages/FormStudent'));
export const FormGeneral = lazy(() => import('../pages/FormGeneral'));
export const TermsOfUse = lazy(() => import('../pages/TermsOfUse'));



